import { render } from "./PrefillFormNotification.vue?vue&type=template&id=f9030cd8&ts=true"
import script from "./PrefillFormNotification.vue?vue&type=script&lang=ts"
export * from "./PrefillFormNotification.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__